module.exports = __webpack_public_path__ + "static/banner-texture-7cec2118306141f2650c34ca1b7ae37d.jpg";